import { jsx as _jsx } from "react/jsx-runtime";
export const Datalist = ({ id, options }) => (_jsx("datalist", { id: id, children: options.map(opt => (_jsx("option", { value: opt }, opt.replace(/\s/g, '')))) }));
